import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { he } from 'date-fns/locale';
import React from 'react';
import { Schema } from '../../../../../amplify/data/resource';
import PaymentItem from './PaymentItem';

// @ts-ignore
type Payment = Schema['AgentPaymentLink']['type'];

interface FileListProps {
  payments: Payment[];
}

const PaymentList: React.FC<FileListProps> = ({ payments }) => {
  let lastMonth: string | null = null;

  return (
    <Box sx={{ direction: 'rtl', width: '100%' }}>
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          maxHeight: '600px',
          overflowY: 'auto',
        }}
      >
        <Table
          stickyHeader
          sx={{
            backgroundColor: 'transparent',
            borderCollapse: 'separate',
            borderSpacing: '0 10px',
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: 'transparent' }}>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  תאריך ושעה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  שם לקוח
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  חברה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  מוצר
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סכום
                </Typography>
              </TableCell>

              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סטטוס
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                }}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {payments
              .slice()
              .sort(
                (a: any, b: any) =>
                  new Date(b.date).getTime() - new Date(a.date).getTime(),
              )
              .map((payment: Payment, index: any) => {
                const currentMonth = format(
                  new Date(payment.createdAt),
                  'MMMM yyyy',
                  {
                    locale: he,
                  },
                );
                const isNewGroup = currentMonth !== lastMonth;
                lastMonth = currentMonth;

                return (
                  <React.Fragment key={payment.id}>
                    {isNewGroup && index !== 0 && (
                      <TableRow>
                        <TableCell
                          colSpan={7}
                          sx={{
                            padding: '5px 0',
                            backgroundColor: 'transparent',
                            borderBottom: 'none',
                            borderTop: 'none',
                            borderLeft: 'none',
                            borderRight: 'none',
                          }}
                        />
                      </TableRow>
                    )}
                    <PaymentItem payment={payment} />
                  </React.Fragment>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PaymentList;
